import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { interval } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-paga-tu-cuenta',
  templateUrl: './paga-tu-cuenta.component.html',
  styleUrls: ['./paga-tu-cuenta.component.scss']
})
export class PagaTuCuentaComponent implements OnInit {
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);
  
  constructor(
    private titleService: Title,
    private metaService:Meta,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
  ) { }

  sub: any;

  ngOnInit(): void {
    this.titleService.setTitle('Paga tu cuenta Metrogas | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Para pagar tu cuenta Metrogas de forma rápida y segura, ingresa a www.metrogas.cl, en la pestaña de pago fácil o pago online.' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
    }
  }
}
